import { ReactNode } from "react";
import { Row, Col, ButtonProps } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { Body, Button, Modal, Title } from "./ConfirmDialog.style";

const styles = {
  buttonGroup: { marginTop: "16px" },
  button: { margin: "4px 0px" },
};

export type ConfirmDialogProps = {
  title: ReactNode;
  description: ReactNode;
  onConfirm?: () => void;
  onReject?: () => void;
  isVisible?: boolean;
  confirmButtonProps?: ButtonProps;
  rejectButtonProps?: ButtonProps;
  confirmText?: string | JSX.Element;
  rejectText?: string | JSX.Element;
  primaryButtonOnRight?: boolean;
  fullWidthButton?: boolean;
  centered?: boolean;
};

const ConfirmDialog = ({
  title,
  description,
  isVisible = true,
  onConfirm,
  onReject,
  confirmButtonProps,
  rejectButtonProps,
  confirmText = "Confirm",
  rejectText = "No",
  primaryButtonOnRight = false,
  fullWidthButton = false,
  centered = false,
}: ConfirmDialogProps) => {
  const { sm } = useBreakpoint();
  return (
    <Modal
      destroyOnClose
      centered={centered}
      width={sm ? "303px" : "auto"}
      visible={isVisible}
      footer={null}
      closable={false}
      data-testid="confirm-dialog-modal"
      data-gtm-input-code="confirm-dialog-modal"
    >
      <Title>{title}</Title>
      <Body>{description}</Body>
      <Row justify="center" gutter={8} style={styles.buttonGroup}>
        <Col
          span={fullWidthButton ? 24 : 12}
          order={primaryButtonOnRight ? 1 : 0}
        >
          <Button
            type="primary"
            data-testid="confirm-dialog-confirm-button"
            data-gtm-input-code="confirm-dialog-confirm-button"
            onClick={onConfirm}
            style={styles.button}
            {...confirmButtonProps}
          >
            {confirmText}
          </Button>
        </Col>
        <Col
          span={fullWidthButton ? 24 : 12}
          order={primaryButtonOnRight ? 0 : 1}
        >
          <Button
            type="outlined"
            data-testid="confirm-dialog-reject-button"
            data-gtm-input-code="confirm-dialog-reject-button"
            onClick={onReject}
            style={styles.button}
            {...rejectButtonProps}
          >
            {rejectText}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};
export default ConfirmDialog;
